import DownloadDialog from './DownloadDialog';

export default { 
  name: "download", 
  component: DownloadDialog, 
  fullScreen: false
};